import {createContext, useEffect, useState} from "react";
import {internalApi} from "../../common/axios";

export const AuthContext = createContext();

export const AuthContextProvider = ({children}) => {
    const [currentUser, setCurrentUser] = useState(
        JSON.parse(sessionStorage.getItem("user")) || null
    );

    const channel = new BroadcastChannel('environment-settings');

    useEffect(() => {
        channel.onmessage = (event) => {
            const {user} = event.data;
            setCurrentUser(user);
            window.location.reload();
        };
    },);

    useEffect(() => {
        sessionStorage.setItem("user", JSON.stringify(currentUser));
    }, [currentUser]);

    const changeEnv = async (env) => {
        const res = await internalApi.post("auth/changeEnv", {env});
        if (res.status === 200) {
            setCurrentUser(res.data.user);
            channel.postMessage({user: res.data.user});
        } else {
            setCurrentUser(null);
        }
    };

    return (
        <AuthContext.Provider
            value={{
                currentUser,
                setCurrentUser,
                changeEnv,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};